import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SessionState {
  isAuthenticated: boolean;
  lastScreen: string;
  user: {
    id: string | null;
    email: string | null;
    name: string | null;
  };
}

const initialState: SessionState = {
  isAuthenticated: false,
  lastScreen: "/",
  user: {
    id: null,
    email: null,
    name: null,
  },
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setLastScreen: (state, action: PayloadAction<string>) => {
      state.lastScreen = action.payload;
    },
    setUser: (state, action: PayloadAction<SessionState["user"]>) => {
      state.user = action.payload;
    },
    clearSession: (state) => {
      state.isAuthenticated = false;
      state.user = {
        id: null,
        email: null,
        name: null,
      };
      state.lastScreen = "/";
    },
  },
});

export const { setAuthenticated, setLastScreen, setUser, clearSession } =
  sessionSlice.actions;
export default sessionSlice.reducer;

export type { SessionState };
